import { acknowledgeUserIdentityConflict } from '~src/app/actions/spaces/UserIdentityActions';
import { IUserIdentityConflictInfo } from '~src/authentication/models/IUserIdentityConflictInfo';

import { Messages } from '../../../../codegen/Localize';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const AcknowledgeUserIdentityConflictAction: IEntityAction<IUserIdentityConflictInfo, {}> = {
  name: EntityActionNames.AcknowledgeUserIdentityConflict,
  translateName: Messages.identityMigration_AcknowledgeUserIdentityConflict,
  isVisible: (targetItems: IUserIdentityConflictInfo[], state: AppState) => true,
  isClickable: areAllConflictsNotAcknowledged,
  createReduxAction: (targetItems: IUserIdentityConflictInfo[]) => acknowledgeUserIdentityConflict(targetItems)
};

function areAllConflictsNotAcknowledged(availableActions: {}, targetItems: IUserIdentityConflictInfo[], state: AppState): boolean {
  return targetItems.every(x => !x.acknowledged);
}
